import React from 'react';
import { HelpCircleIcon, LayersIcon, RepeatIcon, RouteIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  layers: LayersIcon,
  help: HelpCircleIcon,
  route: RouteIcon,
  repeat: RepeatIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-white text-brand-petrol" data-id="element-130" data-mp="2vpg3o38cyxg1">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-131" data-mp="39hcqpsv66h5k">
        <p className="inline-block rounded-md bg-brand-petrol px-2 py-0.5 font-sub text-xs font-semibold uppercase tracking-widest text-brand-mint" data-id="element-132" data-mp="35gas9e92u94n">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[2rem] leading-none sm:text-5xl" data-id="element-133" data-mp="3jdpmqxe6t73h">
          Querés entender farmacología,{' '}
          <span className="bg-brand-mint px-1" data-id="element-134" data-mp="1p2kl1ymnv4qs">
            pero los nombres, mecanismos y efectos terminan mezclándose.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted" data-id="element-135" data-mp="jddgajcd4x0t">
          Si estás cursando enfermería o necesitás reforzar tus conocimientos,
          probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-136" data-mp="sd05m6rticdi">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-l-4 border-brand-petrol bg-brand-ivory p-2.5 text-left" data-id="element-137" data-mp="1244jf35rbr6r" data-mpi={i}>
                <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-brand-petrol" data-id="element-138" data-mp="1c2k9d2t1sueo">
                  <Icon size={15} className="text-brand-mint" data-id="element-139" data-mp="1g11jzwbogn0u" />
                </span>
                <div data-id="element-140" data-mp="3dv8jzx80uk4h">
                  <h3 className="font-sub text-sm font-bold uppercase leading-tight" data-id="element-141" data-mp="3hur5au3r8x7u">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-142" data-mp="p11yo2fuinkj">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}